import getFormatMessage from '../../locales/get-format-message';
import { LayoutDefault } from '../../router/templates/default';
import styles from './style.module.scss';
import './new-home.scss';
import './service-card.scss';
import aboutIngameIcon from '../../assets/svg/about-ingame.svg';
import { useHistory } from 'react-router-dom';
import streamlinedEfficiency from '../../assets/svg/benifit-one-icon.svg';
import enterpriseGrade from '../../assets/svg/benifit-two-icon.svg';
import unlimitedFlexibility from '../../assets/svg/benifit-three-icon.svg';
import crossPlatform from '../../assets/images/cross-platform.png';
// import theEarth from '../../assets/images/the-earth.png';
// import parnterShowcase from '../../assets/images/parnter-showcase.png';
import parnterOne from '../../assets/images/parnter-one.png';
import parnterTwo from '../../assets/images/parnter-two.png';
import parnterThree from '../../assets/images/parnter-three.png';
import parnterFour from '../../assets/images/parnter-four.png';
import dnvLeft from '../../assets/images/dnv-left.png';
import dnvRight from '../../assets/images/dnv-right.png';
import classNames from 'classnames';
import { Input, Modal } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { getConfig } from '../../config';
import { getLocaleLanguage, LanguageType } from '../../lib';
import AnimatedContent from '../../animations/animated-content/animated-content';
import GradientText from '../../text-animations/gradient-text/gradient-text';
// import LightRays from '../../backgrounds/light-rays/light-rays';
// import Galaxy from '../../backgrounds/galaxy/galaxy-bg';
import LogoLoop from '../../animations/logo-loop/logo-loop';
import multiplayerIcon from '../../assets/images/home-multiplayer.png';
import analyticsIcon from '../../assets/images/home-analytics.png';
import economyIcon from '../../assets/images/home-economy.png';
import engageIcon from '../../assets/images/home-engage.png';
import contentIcon from '../../assets/images/home-content.png';
import socialIcon from '../../assets/images/home-social.png';
import servicesTopIcon from '../../assets/images/services-top-icon.png';
import contactIcon from '../../assets/images/footer-contact.png';
// import serviceTipsModal from '../../assets/svg/service-tips-modal.svg';
import homeBgOne from '../../assets/svg/home-bg-one.svg';
import homeBgThree from '../../assets/images/home-bg-three.avif';
import homeBgFour from '../../assets/svg/home-bg-four.svg';
import globalIconOne from '../../assets/svg/global-icon-one.svg';
import globalIconOneHover from '../../assets/images/global-icon-one-hover.png';
import globalIconTwo from '../../assets/svg/global-icon-two.svg';
import globalIconTwoHover from '../../assets/svg/global-icon-two-hover.svg';
import globalIconThree from '../../assets/svg/global-icon-three.svg';
import globalIconThreeHover from '../../assets/svg/global-icon-three-hover.svg';
import globalIconFour from '../../assets/svg/global-icon-four.svg';
import globalIconFourHover from '../../assets/svg/global-icon-four-hover.svg';
import homeBgSix from '../../assets/images/home-bg-six.avif';
import noticeItemBgMock from '../../assets/images/home/banner-tips-bg.jpg';

import { AppEnvType, DeployArea } from '../../model';
import { getLoginToken } from '../lib';
import { getIconUrl } from '../../lib/cdn-icon-url';

const { Search } = Input;
export const NewHomeRoute = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');
  const [servicesActive, setServicesActive] = useState<number>(0);
  // const [benifitsActive, setBenifitsActive] = useState<number>(0);
  const [globalActive, setGlobalActive] = useState<number>(0);
  // Backgrounds下的动画依赖于ogl的都需要等showAurora延迟设置为true才能执行 不然拿不到值报错
  // const [showAurora, setShowAurora] = useState<boolean>(false);
  const [securityAnimated, setSecurityAnimated] = useState<boolean>(false);
  const [showEarth, setShowEarth] = useState<boolean>(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const userURL = getConfig()?.userURL;
  const history = useHistory();
  const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
  const deployArea: DeployArea = getConfig()?.deployArea;
  const isWoa = deployArea === DeployArea.woa;
  const viewerRef = useRef<any>(null);
  const ticket = getLoginToken();
  const consoleURL = getConfig()?.consoleURL;

  const divBodyRef = useRef(null);
  const [inView1, setInView1] = useState<boolean>(false);
  const [configData, setConfigData] = useState<any>();

  const isMobileCheck =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  useEffect(() => {
    function handleScroll(this: Window, e: WheelEvent) {
      if (!inView1) {
        if (e.deltaY < 0) {
          document.body.classList.add('scroll-down');
        } else {
          document.body.classList.remove('scroll-down');
        }
      }
    }
    window.addEventListener('wheel', handleScroll);
    // 清理函数：移除事件监听器
    return () => {
      window.removeEventListener('wheel', handleScroll);
    };
  }, [inView1]);

  const divPlatformRef = useRef(null);
  const [inPlatformView, setInPlatformView] = useState<boolean>(false);

  const divBenifitRef = useRef(null);
  const [inBenifitView, setInBenifitView] = useState<boolean>(false);

  const divBenifitCardRef = useRef(null);
  const [inBenifitCardView, setInBenifitCardView] = useState<boolean>(false);

  const divServerBoxTitleRef = useRef(null);
  const [inServiceTitleView, setInServiceTitleView] = useState<boolean>(false);

  const divGlobalServiceRef = useRef(null);
  const [inGlobalServiceView, setInGlobalServiceView] =
    useState<boolean>(false);

  const divGlobalContRef = useRef(null);
  const [inGlobalContView, setInGlobalContView] = useState<boolean>(false);

  const divOurServiceRef = useRef(null);
  const [inOurServiceView, setInOurServiceView] = useState<boolean>(false);

  const divServiceBannerRef = useRef(null);
  const [inServiceBannerView, setInServiceBannerView] =
    useState<boolean>(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // 根据目标元素的ref来更新对应的状态
          if (entry.target === divBodyRef.current) {
            const { isIntersecting } = entry;
            setInView1(isIntersecting);

            // 当元素进入视口后，停止观察
            if (isIntersecting) {
              observer.unobserve(entry.target);
            }
          }

          if (entry.target === divPlatformRef.current) {
            const { isIntersecting } = entry;
            setInPlatformView(isIntersecting);

            // 当元素进入视口后，停止观察
            if (isIntersecting) {
              observer.unobserve(entry.target);
            }
          }

          if (entry.target === divBenifitRef.current) {
            const { isIntersecting } = entry;
            setInBenifitView(isIntersecting);

            // 当元素进入视口后，停止观察
            if (isIntersecting) {
              observer.unobserve(entry.target);
            }
          }

          if (entry.target === divBenifitCardRef.current) {
            const { isIntersecting } = entry;
            setInBenifitCardView(isIntersecting);

            // 当元素进入视口后，停止观察
            if (isIntersecting) {
              observer.unobserve(entry.target);
            }
          }

          if (entry.target === divServerBoxTitleRef.current) {
            const { isIntersecting } = entry;
            setInServiceTitleView(isIntersecting);

            // 当元素进入视口后，停止观察
            if (isIntersecting) {
              observer.unobserve(entry.target);
            }
          }

          if (entry.target === divGlobalServiceRef.current) {
            const { isIntersecting } = entry;
            setInGlobalServiceView(isIntersecting);

            // 当元素进入视口后，停止观察
            if (isIntersecting) {
              observer.unobserve(entry.target);
            }
          }

          if (entry.target === divGlobalContRef.current) {
            const { isIntersecting } = entry;
            setInGlobalContView(isIntersecting);

            // 当元素进入视口后，停止观察
            if (isIntersecting) {
              observer.unobserve(entry.target);
            }
          }

          if (entry.target === divOurServiceRef.current) {
            const { isIntersecting } = entry;
            setInOurServiceView(isIntersecting);
            if (isIntersecting) {
              observer.unobserve(entry.target);
            }
          }

          if (entry.target === divServiceBannerRef.current) {
            const { isIntersecting } = entry;
            setInServiceBannerView(isIntersecting);
            if (isIntersecting) {
              observer.unobserve(entry.target);
            }
          }
        });
      },
      {
        // 配置选项
        threshold: 0.1, // 当10%的元素可见时触发
        rootMargin: '0px', // 视窗的边界
      }
    );

    // 开始观察元素
    if (
      divBodyRef.current &&
      divPlatformRef.current &&
      divBenifitRef.current &&
      divBenifitCardRef.current &&
      divServerBoxTitleRef.current &&
      divGlobalServiceRef.current &&
      divGlobalContRef.current &&
      divOurServiceRef.current &&
      divServiceBannerRef.current
    ) {
      observer.observe(divBodyRef.current);
      observer.observe(divPlatformRef.current);
      observer.observe(divBenifitRef.current);
      observer.observe(divBenifitCardRef.current);
      observer.observe(divServerBoxTitleRef.current);
      observer.observe(divGlobalServiceRef.current);
      observer.observe(divGlobalContRef.current);
      observer.observe(divOurServiceRef.current);
      observer.observe(divServiceBannerRef.current);
    }

    // 清理函数
    return () => {
      if (
        divBodyRef.current &&
        divPlatformRef.current &&
        divBenifitRef.current &&
        divBenifitCardRef.current &&
        divServerBoxTitleRef.current &&
        divGlobalServiceRef.current &&
        divGlobalContRef.current &&
        divOurServiceRef.current &&
        divServiceBannerRef.current
      ) {
        observer.unobserve(divBodyRef.current);
        observer.unobserve(divPlatformRef.current);
        observer.unobserve(divBenifitRef.current);
        observer.unobserve(divBenifitCardRef.current);
        observer.unobserve(divServerBoxTitleRef.current);
        observer.unobserve(divGlobalServiceRef.current);
        observer.unobserve(divGlobalContRef.current);
        observer.unobserve(divOurServiceRef.current);
        observer.unobserve(divServiceBannerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    // 组件挂载后先执行第一个隐藏地球
    setShowEarth(true);
    let timerId: any;
    let retries = 0;
    const maxRetries = 10; // 设置最大重试次数
    const interval = 800; // 每次间隔800毫秒

    const checkOglRenderer = () => {
      if (window.oglRenderer) {
        // setShowAurora(true);
      } else if (retries < maxRetries) {
        retries += 1;
        timerId = setTimeout(checkOglRenderer, interval);
      }
    };

    // 立即检查一次
    checkOglRenderer();

    // 清除定时器以防组件卸载
    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, []);

  useEffect(() => {
    const { hash } = window.location;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  // 小写去空格
  const toLowerCaseAndRemoveSpaces = (str: string) => {
    return str.toLowerCase().replace(/\s+/g, '');
  };

  const geToProduct = (item: string) => {
    history.push(`/products/${toLowerCaseAndRemoveSpaces(item)}`);
  };

  const handleSearch = () => {
    const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
    const params = new URLSearchParams();
    if (email) {
      params.append('email', email);
    }
    if (currentStoreLanguage) {
      params.append('ingame_language', currentStoreLanguage);
    }
    const queryString = params.toString();
    const url = `${userURL}/contact${queryString ? `?${queryString}` : ''}`;
    window.location.href = url;
  };

  const getVideoUrl = () => {
    const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
    if (currentStoreLanguage === LanguageType.en_US) {
      return 'https://gcloudintl-prod-1316968258.cos.ap-singapore.myqcloud.com/ingame-website/InGameIntroduction/EN-InGameIntroductionVedio.mp4';
    }
    return 'https://gcloudintl-prod-1316968258.cos.ap-singapore.myqcloud.com/ingame-website/InGameIntroduction/CN-InGameIntroductionVedio.mp4';
  };

  const loopItems = [
    { node: <img src={parnterOne} className={styles.parnterPngOne} /> },
    { node: <img src={parnterTwo} className={styles.parnterPngTwo} /> },
    { node: <img src={parnterThree} className={styles.parnterPngThree} /> },
    { node: <img src={parnterFour} className={styles.parnterPngFour} /> },
  ];

  const init = async () => {
    const appConfig = getConfig();
    const configUrl = appConfig.cdnURL
      ? `${appConfig.cdnURL}/ingame-website/homepage/config/${
          appConfig.env === AppEnvType.Production ? 'prodconfig' : 'testconfig'
        }/${
          currentStoreLanguage === LanguageType.zh_CN
            ? 'ZH_home_config'
            : 'EN_home_config'
        }.json`
      : '';
    if (!configData) {
      try {
        const response = await fetch(configUrl);
        if (!response.ok) {
          return console.log('error');
        }
        const data = await response.json(); // 解析JSON格式的响应体

        if (data) {
          setConfigData(data);
        }
      } catch (error) {
        console.error('There was a problem with your fetch operation:', error);
      }
    }
  };

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (videoRef.current) {
      if (isModalOpen) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (!isMobileCheck) {
      const splineViewer: any = document.querySelector('spline-viewer');
      let isScrolling = false;
      let isMouseOverSpline = false;

      // 鼠标进入/离开 Spline
      splineViewer.addEventListener('mouseenter', () => {
        isMouseOverSpline = true;
      });
      splineViewer.addEventListener('mouseleave', () => {
        isMouseOverSpline = false;
      });

      // 滚轮事件
      splineViewer.addEventListener(
        'wheel',
        (event: any) => {
          const delta = event.deltaY;

          if (isMouseOverSpline) {
            event.preventDefault(); // 仅在 Spline 内阻止默认行为
            if (!isScrolling) {
              isScrolling = true;
              requestAnimationFrame(() => {
                window.scrollBy({
                  top: delta * 1.2, // 调整滚动速度
                  behavior: 'auto',
                });
                isScrolling = false;
              });
            }
          }
        },
        { passive: false }
      );

      splineViewer.addEventListener('load-complete', () => {
        splineViewer._$Do.options.host._logo.style.display = 'none';
      });
    }

    if (viewerRef.current) {
      // 尝试调用 load 方法（如果存在）
      if (typeof (viewerRef.current as any).load === 'function') {
        (viewerRef.current as any).load();
      } else {
        // 如果没有 load 方法，尝试调整大小以触发加载
        // viewerRef.current.dispatchEvent(new Event('resize'));
        const event = new Event('resize');
        window.dispatchEvent(event);
      }
    }
  }, []);

  const handleServicesMouseEnter = (key: number) => {
    setServicesActive(key);
  };

  // const handleBenifitMouseEnter = (key: number) => {
  //   setBenifitsActive(key);
  // };

  const handleGlobalMouseEnter = (key: number) => {
    setGlobalActive(key);
  };

  const goContactUs = () => {
    if (ticket && consoleURL) {
      const url = new URL(`https://${consoleURL}`);
      url.searchParams.append('ingame_language', currentStoreLanguage);
      window.open(url.toString(), '_blank');
      return;
    }
    window.open(
      `${userURL}/contact?ingame_language=${currentStoreLanguage}`,
      '_self'
    );
  };

  const handleWheel = (e: React.WheelEvent) => {
    e.preventDefault();
  };

  const [swiperFeatureRef, setSwiperFeatureRef] = useState<HTMLElement | null>(
    null
  );

  const [swiperFeatureInitialized, setSwiperFeatureInitialized] =
    useState<boolean>(false);

  const [swiperBannerTipsRef, setSwiperBannerTipsRef] =
    useState<HTMLElement | null>(null);
  const [swiperBannerTipsInitialized, setSwiperBannerTipsInitialized] =
    useState<boolean>(false);

  const [swiperPartnerRef, setSwiperPartnerRef] = useState<HTMLElement | null>(
    null
  );

  useEffect(() => {
    if (window.Swiper && swiperFeatureRef) {
      const swiperFeature = new window.Swiper(swiperFeatureRef, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 30,
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination-feature',
          clickable: true,
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      });

      setSwiperFeatureInitialized(true);

      return () => {
        if (swiperFeature) {
          swiperFeature.destroy(true, true);
        }
      };
    }
  }, [swiperFeatureInitialized, swiperFeatureRef]);

  useEffect(() => {
    // console.log("useEffect,swiperBannerTipsRef:@@1",swiperBannerTipsRef.current);
    // console.log("useEffect,swiperBannerTipsRef:@@2",window.Swiper);
    if (window.Swiper && swiperBannerTipsRef) {
      const swiperBannerTips = new window.Swiper(swiperBannerTipsRef, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 30,
        effect: 'fade',
        simulateTouch: false, // 关闭鼠标拖拽和触摸滑动
        allowTouchMove: false, // 禁止触摸移动
        pagination: {
          el: '.swiper-pagination-banner-tips',
          clickable: true,
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      });
      setSwiperBannerTipsInitialized(true);
      return () => {
        if (swiperBannerTips) {
          swiperBannerTips.destroy(true, true);
        }
      };
    }
  }, [swiperBannerTipsInitialized, swiperBannerTipsRef]);

  const [swiperPartnerInstanceConst, setSwiperPartnerInstanceConst] =
    useState<any>(null);

  useEffect(() => {
    if (window.Swiper && swiperPartnerRef) {
      const swiperPartnerIns = new window.Swiper(swiperPartnerRef, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 30,
        effect: 'fade',
        simulateTouch: false, // 关闭鼠标拖拽和触摸滑动
        allowTouchMove: false, // 禁止触摸移动
        pagination: {
          el: '.swiper-pagination-parnter',
          clickable: true,
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
      });
      setSwiperPartnerInstanceConst(swiperPartnerIns);

      return () => {
        if (swiperPartnerInstanceConst) {
          swiperPartnerInstanceConst.destroy(true, true);
        }
      };
    }
  }, [swiperPartnerRef]);

  const isPlayingRef = useRef(true);
  const [isPlaying, setIsPlaying] = useState<boolean>(true);

  const toggleAutoplay = () => {
    if (swiperPartnerInstanceConst) {
      if (isPlayingRef.current) {
        swiperPartnerInstanceConst.autoplay.stop();
        setIsPlaying(false);
        isPlayingRef.current = false;
      } else {
        swiperPartnerInstanceConst.autoplay.start();
        setIsPlaying(true);
        isPlayingRef.current = true;
      }
    }
  };

  const [showContentMore, setShowContentMore] = useState<boolean>(false);
  console.log(setShowContentMore);

  const clickFeatureBtn = (link: string) => {
    if (link.includes('http') || link.includes('https')) {
      window.open(link, '_blank');
    } else {
      if (consoleURL) {
        const url = `https://${consoleURL}${link}`;
        window.open(url, '_blank');
      }
    }
  };

  const homeFeatures = configData?.HomeFeatures || {};
  const homeNotices = configData?.HomeNotices || {};
  const homePartnerBanner = configData?.HomePartnerBanner || {};

  return (
    <LayoutDefault>
      <div className={` ${styles.newHomePage} homepage-content`}>
        {showEarth && (
          <div></div>
          // <div
          //   className="spline-container"
          //   style={{ position: 'absolute', zIndex: -99, visibility: 'hidden' }}
          // >
          //   <spline-viewer
          //     ref={viewerRef}
          //     url="/spline-static/scene.splinecode"
          //     events-target="global"
          //   />
          // </div>
        )}
        <img src={homeBgOne} className={styles.homeBgOne} />
        <img src={homeBgThree} className={styles.homeBgThree} />
        <img src={homeBgFour} className={styles.homeBgFour} />
        <div className={styles.headerBgBox}>
          <div className={styles.headerBgMaskBox}></div>
          <div className={styles.headerBox}>
            <div className={styles.headerTipsOne}>
              {getFormatMessage('simplify_game')}
            </div>
            <div className={`head-title ${styles.headerTipsTwo}`}>
              <span>Tencent Games InGame</span>
            </div>
            <div className={styles.headerTipsThree}>
              {getFormatMessage('ingame_desc')}
            </div>
            <div className={styles.headerBtnBox}>
              <div className="head-button" onClick={() => goContactUs()}>
                <div className="head-button-text">
                  <strong>{getFormatMessage('start_for_free')}</strong>
                </div>
                <div className="head-button-bg">
                  <div className="head-button-light"></div>
                  <div className="head-button-light-bg"></div>
                </div>
              </div>

              <div
                className="head-button-primary"
                onClick={() => setIsModalOpen(true)}
              >
                <div className="head-button-primary-text">
                  <img src={aboutIngameIcon} />
                  <strong>{getFormatMessage('about_ingame')}</strong>
                </div>
                <div className="head-button-primary-bg">
                  <div className="head-button-primary-light"></div>
                  <div className="head-button-primary-light-bg"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.bodyBox}>
          {homeFeatures?.list && homeFeatures.list.length > 0 && (
            <div
              className={`${styles.featureContentWrapBox} ${
                styles[`headFeatureList${homeFeatures.list.length}`]
              }`}
            >
              <div
                className={`swiper swiper-feature-box ${styles.swiperFeatureBox}`}
                ref={(val) => {
                  setSwiperFeatureRef(val);
                }}
              >
                <div
                  className={`swiper-wrapper ${styles.swiperFeatureBoxWrap}`}
                >
                  {homeFeatures.list.map((item: any) => {
                    return (
                      <div
                        className={`swiper-slide ${styles.swiperFeatureBoxItem}`}
                      >
                        <div className={styles.headFeatureCard}>
                          <div className={styles.headFeatureCardCover}>
                            <img src={getIconUrl(item?.cover || '')} alt="" />
                          </div>
                          <div className={styles.headFeatureCardBody}>
                            <h4 className={styles.headFeatureCardTitle}>
                              {item?.title || ''}
                            </h4>
                            <div className={styles.headFeatureCardDesc}>
                              {item?.desc || ''}
                            </div>
                            {item?.link && (
                              <div className={styles.headFeatureCardAction}>
                                <a
                                  className={styles.headFeatureCardLink}
                                  onClick={() => clickFeatureBtn(item.link)}
                                >
                                  <span>
                                    {getFormatMessage('find_out_more')}
                                  </span>
                                </a>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="swiper-pagination swiper-pagination-feature"></div>
              </div>
            </div>
          )}

          <div className={styles.servicesBox} id="servicesBox">
            <div
              ref={divServerBoxTitleRef}
              className={`${styles.servercieBoxTitle} ${
                inServiceTitleView ? 'service-title-in-view' : ''
              }`}
            >
              <div
                className={`servicesTopIconBox ${styles.servicesTopIconBox}`}
              >
                <img src={servicesTopIcon} className={styles.servicesTopIcon} />
              </div>
              <div className={`ourServices ${styles.ourServices}`}>
                <span
                  className={classNames(
                    styles.ourServicesSpan,
                    currentStoreLanguage === LanguageType.zh_CN
                      ? ''
                      : styles.ourServicesCourier
                  )}
                >
                  {getFormatMessage('our_services')}
                </span>
              </div>
              <div className={`ourServicesTips ${styles.ourServicesTips}`}>
                <div>{getFormatMessage('out_of_box_one')}</div>
                <div className={styles.ourServicesTipsTwo}>
                  <span>{getFormatMessage('out_of_box_two')}</span>
                </div>
              </div>
            </div>

            <div
              ref={divBodyRef}
              className={`${styles.servicesContentWrap} ${
                inView1 ? 'service-in-view' : ''
              }`}
            >
              {homeNotices?.list && homeNotices.list.length > 0 && (
                <div
                  className={`swiper swiper-banner-tips ${styles.bannerTips}`}
                  ref={(val) => {
                    setSwiperBannerTipsRef(val);
                  }}
                >
                  <div
                    className={`swiper-wrapper ${styles.swiperBannerTipsWrap}`}
                  >
                    {homeNotices.list.map((item: any) => {
                      return (
                        <div
                          className={`swiper-slide ${styles.swiperBannerTipsItem}`}
                        >
                          <div className={styles.bannerTipsCard}>
                            <div className={styles.bannerTipsCardCont}>
                              <h4 className={styles.bannerTipsCardTitle}>
                                <span
                                  className={styles.bannerTipsCardTitleText}
                                >
                                  {item?.title || ''}
                                </span>
                                <label className={styles.bannerTipsCardLabel}>
                                  {item?.label || ''}
                                </label>
                              </h4>
                              <div className={styles.bannerTipsCardDesc}>
                                {item?.desc || ''}
                              </div>
                            </div>
                            <div className={styles.bannerTipsCardBorder}></div>
                            <div className={styles.bannerTipsCardContBg}>
                              <img src={noticeItemBgMock} alt="" />
                              <div className={styles.bannerTipsCardBgEle}></div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div
                    className={`swiper-pagination swiper-pagination-banner-tips ${styles.swiperBannerTipsPage}`}
                  ></div>
                </div>
              )}

              <div className={styles.servicesContentBox}>
                <div
                  className={classNames(
                    `mod-service-card`,
                    styles.servicesPositionBoxBig,
                    servicesActive === 0 ? 'service-content-active' : ''
                  )}
                >
                  <div className="service-card-bg">
                    <div className="service-card-light"></div>
                    <div className="service-card-light-bg"></div>
                  </div>
                  <div className="service-card-bg-border"></div>

                  <div className="games-bg">
                    <div className="games-bg-lightbox">
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                    </div>
                  </div>
                  <div className={styles.servicesItemBox}>
                    <div
                      className={classNames(
                        styles.bigServiceBox,
                        servicesActive === 0 ? styles.serviceBoxActive : ''
                      )}
                      onMouseEnter={() => handleServicesMouseEnter(0)}
                      onClick={() => handleServicesMouseEnter(0)}
                    >
                      <div className={styles.bigServiceBoxHead}>
                        <div className={styles.serviceIcon}>
                          <img src={multiplayerIcon} />
                        </div>
                        <div className={styles.serviceTitle}>Multiplayer</div>
                      </div>
                      <div className={styles.serviceDesc}>
                        {getFormatMessage('multiplayer_desc')}
                      </div>
                      <div className={styles.serviceItemBox}>
                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Player')}
                        >
                          <div className="service-card-button-text">Player</div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>
                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Party')}
                        >
                          <div className="service-card-button-text">Party</div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>
                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Lobby')}
                        >
                          <div className="service-card-button-text">Lobby</div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>
                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Matchmaking')}
                        >
                          <div className="service-card-button-text">
                            Matchmaking
                          </div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>
                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Goals')}
                        >
                          <div className="service-card-button-text">Goals</div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>
                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Custom Data')}
                        >
                          <div className="service-card-button-text">
                            Custom Data
                          </div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>
                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('DS Hosting')}
                        >
                          <div className="service-card-button-text">
                            DS Hosting
                          </div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>
                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Microservice')}
                        >
                          <div className="service-card-button-text">
                            Microservice
                          </div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>
                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('BattlePass')}
                        >
                          <div className="service-card-button-text">
                            BattlePass
                          </div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={classNames(
                    `mod-service-card`,
                    styles.servicesPositionBoxSmall,
                    servicesActive === 1 ? 'service-content-active' : ''
                  )}
                >
                  <div className="service-card-bg">
                    <div className="service-card-light"></div>
                    <div className="service-card-light-bg"></div>
                  </div>
                  <div className="service-card-bg-border"></div>
                  <div className="games-bg">
                    <div className="games-bg-lightbox">
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                    </div>
                  </div>
                  <div className={styles.servicesItemBox}>
                    <div
                      className={classNames(
                        styles.smallServiceBox,
                        servicesActive === 1 ? styles.serviceBoxActive : ''
                      )}
                      onMouseEnter={() => handleServicesMouseEnter(1)}
                      onClick={() => handleServicesMouseEnter(1)}
                    >
                      <div className={styles.smallServiceHeaderBox}>
                        <div className={styles.serviceIcon}>
                          <img src={economyIcon} />
                        </div>
                        <div className={styles.serviceTitle}>Economy</div>
                      </div>
                      <div className={styles.serviceDesc}>
                        {getFormatMessage('economy_desc')}
                      </div>
                      <div className={styles.serviceItemBox}>
                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Game Items')}
                        >
                          <div className="service-card-button-text">
                            Game Items
                          </div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>

                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Store')}
                        >
                          <div className="service-card-button-text">Store</div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={classNames(
                    `mod-service-card`,
                    styles.servicesPositionBoxSmall,
                    servicesActive === 2 ? 'service-content-active' : ''
                  )}
                >
                  <div className="service-card-bg">
                    <div className="service-card-light"></div>
                    <div className="service-card-light-bg"></div>
                  </div>
                  <div className="service-card-bg-border"></div>
                  <div className="games-bg">
                    <div className="games-bg-lightbox">
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                    </div>
                  </div>
                  <div className={styles.servicesItemBox}>
                    <div
                      className={classNames(
                        styles.smallServiceBox,
                        servicesActive === 2 ? styles.serviceBoxActive : ''
                      )}
                      onMouseEnter={() => handleServicesMouseEnter(2)}
                      onClick={() => handleServicesMouseEnter(2)}
                    >
                      <div className={styles.smallServiceHeaderBox}>
                        <div className={styles.serviceIcon}>
                          <img src={contentIcon} />
                        </div>
                        <div className={styles.serviceTitle}>Content</div>
                      </div>
                      <div className={styles.serviceDesc}>
                        {getFormatMessage('content_desc')}
                      </div>
                      <div className={styles.serviceItemBox}>
                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Remote Config')}
                        >
                          <div className="service-card-button-text">
                            Remote Config
                          </div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>

                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Dynamic Update')}
                        >
                          <div className="service-card-button-text">
                            Dynamic Update
                          </div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>

                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Launch Update')}
                        >
                          <div className="service-card-button-text">
                            Launch Update
                          </div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={classNames(
                    `mod-service-card`,
                    styles.servicesPositionBoxSmall,
                    servicesActive === 3 ? 'service-content-active' : ''
                  )}
                >
                  <div className="service-card-bg">
                    <div className="service-card-light"></div>
                    <div className="service-card-light-bg"></div>
                  </div>
                  <div className="service-card-bg-border"></div>
                  <div className="games-bg">
                    <div className="games-bg-lightbox">
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                    </div>
                  </div>
                  <div className={styles.servicesItemBox}>
                    <div
                      className={classNames(
                        styles.smallServiceBox,
                        servicesActive === 3 ? styles.serviceBoxActive : ''
                      )}
                      onMouseEnter={() => handleServicesMouseEnter(3)}
                      onClick={() => handleServicesMouseEnter(3)}
                    >
                      <div className={styles.smallServiceHeaderBox}>
                        <div className={styles.serviceIcon}>
                          <img src={analyticsIcon} />
                        </div>
                        <div className={styles.serviceTitle}>Analytics</div>
                      </div>
                      <div className={styles.serviceDesc}>
                        {getFormatMessage('analytics_desc')}
                      </div>
                      <div className={styles.serviceItemBox}>
                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Analytics')}
                        >
                          <div className="service-card-button-text">
                            Analytics
                          </div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={classNames(
                    `mod-service-card`,
                    styles.servicesPositionBoxSmall,
                    servicesActive === 4 ? 'service-content-active' : ''
                  )}
                >
                  <div className="service-card-bg">
                    <div className="service-card-light"></div>
                    <div className="service-card-light-bg"></div>
                  </div>
                  <div className="service-card-bg-border"></div>
                  <div className="games-bg">
                    <div className="games-bg-lightbox">
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                    </div>
                  </div>
                  <div className={styles.servicesItemBox}>
                    <div
                      className={classNames(
                        styles.smallServiceBox,
                        servicesActive === 4 ? styles.serviceBoxActive : ''
                      )}
                      onMouseEnter={() => handleServicesMouseEnter(4)}
                      onClick={() => handleServicesMouseEnter(4)}
                    >
                      <div className={styles.smallServiceHeaderBox}>
                        <div className={styles.serviceIcon}>
                          <img src={engageIcon} />
                        </div>
                        <div className={styles.serviceTitle}>Engagement</div>
                      </div>
                      <div className={styles.serviceDesc}>
                        {getFormatMessage('engage_desc')}
                      </div>
                      <div className={styles.serviceItemBox}>
                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Mails')}
                        >
                          <div className="service-card-button-text">Mails</div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>

                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Privacy Access')}
                        >
                          <div className="service-card-button-text">
                            Privacy Access
                          </div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>

                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Notifications')}
                        >
                          <div className="service-card-button-text">
                            Notifications
                          </div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={classNames(
                    `mod-service-card`,
                    styles.servicesPositionBoxBig,
                    servicesActive === 5 ? 'service-content-active' : ''
                  )}
                >
                  <div className="service-card-bg">
                    <div className="service-card-light"></div>
                    <div className="service-card-light-bg"></div>
                  </div>
                  <div className="service-card-bg-border"></div>
                  <div className="games-bg">
                    <div className="games-bg-lightbox">
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                      <div className="games-bg-light"></div>
                    </div>
                  </div>
                  <div className={styles.servicesItemBox}>
                    <div
                      className={classNames(
                        styles.bigServiceBox,
                        servicesActive === 5 ? styles.serviceBoxActive : ''
                      )}
                      onMouseEnter={() => handleServicesMouseEnter(5)}
                      onClick={() => handleServicesMouseEnter(5)}
                    >
                      <div className={styles.bigServiceBoxHead}>
                        <div className={styles.serviceIcon}>
                          <img src={socialIcon} />
                        </div>
                        <div className={styles.serviceTitle}>Social</div>
                      </div>
                      <div className={styles.serviceDesc}>
                        {getFormatMessage('social_desc')}
                      </div>
                      <div className={styles.serviceItemBox}>
                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Friends')}
                        >
                          <div className="service-card-button-text">
                            Friends
                          </div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>

                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Text Chat')}
                        >
                          <div className="service-card-button-text">
                            Text Chat
                          </div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>

                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Voice Chat')}
                        >
                          <div className="service-card-button-text">
                            Voice Chat
                          </div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>

                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Leaderboards')}
                        >
                          <div className="service-card-button-text">
                            Leaderboards
                          </div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>

                        <div
                          className={classNames(
                            `service-card-button`,
                            styles.serviceItem
                          )}
                          onClick={() => geToProduct('Guild')}
                        >
                          <div className="service-card-button-text">Guild</div>
                          <div className="service-card-button-bg">
                            <div className="service-card-button-light"></div>
                            <div className="service-card-button-light-bg"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            ref={divPlatformRef}
            className={`platform-words ${styles.maximizingBgBox} ${
              inPlatformView ? 'platform-in-view' : ''
            }`}
          >
            <div className={styles.maximizingVideo}>
              <video autoPlay loop muted playsInline>
                <source
                  src="https://gcloudintl-prod-1316968258.cos.ap-singapore.myqcloud.com/ingame-website/websource/InGameWebsource1.mov"
                  type="video/mp4"
                />
              </video>
            </div>
            <div className={`platform-main-content ${styles.maximizingBox}`}>
              <div className={` platform-main-title ${styles.maximizingTips}`}>
                {getFormatMessage('maximizing_your_reach')}
              </div>
              <div className="platform-main-img">
                <img
                  src={crossPlatform}
                  className={` ${styles.maximizingIcon}`}
                />
                <img
                  src={crossPlatform}
                  className={` ${styles.maximizingIcon}`}
                />
              </div>
            </div>
          </div>
          <div className={`benifit-panel ${styles.benifitsBox} `}>
            <div
              ref={divBenifitRef}
              className={`benifit-panel-title ${styles.ourServices} ${
                inBenifitView ? 'benifit-in-view' : ''
              }`}
            >
              <span
                className={classNames(
                  styles.ourServicesSpan,
                  currentStoreLanguage === LanguageType.zh_CN
                    ? ''
                    : styles.ourServicesCourier
                )}
              >
                {getFormatMessage('our_benifits')}
              </span>
            </div>
            <div className={`benifit-panel-tips ${styles.ourServicesTips}`}>
              {getFormatMessage('how_developers')}
            </div>
            <div
              ref={divBenifitCardRef}
              className={`${styles.benifitsContentBox} ${
                inBenifitCardView ? 'benifitcard-in-view' : ''
              }`}
            >
              <div
                className={classNames(
                  `benifit-panel-item`,
                  styles.benifitItemBox,
                  styles.benifitItemBox1
                  // benifitsActive === 0 ? styles.benifitItemBoxActive : ''
                )}
                // onMouseEnter={() => handleBenifitMouseEnter(0)}
              >
                <img
                  src={streamlinedEfficiency}
                  className={styles.benifitItemIcon}
                />
                <div className={styles.benifitItemTitle}>
                  {getFormatMessage('cost_effcient_development')}
                </div>
                <div className={styles.benifitItemDesc}>
                  {getFormatMessage('cost_effcient_development_desc')}
                </div>
              </div>

              <div
                className={classNames(
                  `benifit-panel-item`,
                  styles.benifitItemBox,
                  styles.benifitItemBox2
                  // benifitsActive === 1 ? styles.benifitItemBoxActive : ''
                )}
                // onMouseEnter={() => handleBenifitMouseEnter(1)}
              >
                <img src={enterpriseGrade} className={styles.benifitItemIcon} />
                <div className={styles.benifitItemTitle}>
                  {getFormatMessage('effortless_maintanance')}
                </div>
                <div className={styles.benifitItemDesc}>
                  {getFormatMessage('effortless_maintanance_desc')}
                </div>
                <div className={styles.benifitItemDesc}>
                  {getFormatMessage('effortless_maintanance_desc_two')}
                </div>
              </div>

              <div
                className={classNames(
                  `benifit-panel-item`,
                  styles.benifitItemBox,
                  styles.benifitItemBox3
                  // benifitsActive === 2 ? styles.benifitItemBoxActive : ''
                )}
                // onMouseEnter={() => handleBenifitMouseEnter(2)}
              >
                <img
                  src={unlimitedFlexibility}
                  className={styles.benifitItemIcon}
                />
                <div className={styles.benifitItemTitle}>
                  {getFormatMessage('data_driven_operation')}
                </div>
                <div className={styles.benifitItemDesc}>
                  {getFormatMessage('data_driven_operation_desc')}
                </div>
              </div>
            </div>
          </div>
          <div className={` globalServiceBox ${styles.globalServiceBox} `}>
            <div
              ref={divGlobalServiceRef}
              className={`${
                inGlobalServiceView ? 'global-service-in-view' : ''
              }`}
            >
              <div className={`ourServices ${styles.ourServices}`}>
                <span
                  className={classNames(
                    styles.ourServicesSpan,
                    currentStoreLanguage === LanguageType.zh_CN
                      ? ''
                      : styles.ourServicesCourier
                  )}
                >
                  {getFormatMessage('global_service')}
                </span>
              </div>
              <div className={`ourServicesTips ${styles.ourServicesTips}`}>
                {getFormatMessage('global_support_tips')}
              </div>
            </div>
            <div
              ref={divGlobalContRef}
              className={`globalServiceContentBox ${
                styles.globalServiceContentBox
              } ${inGlobalContView ? 'global-cont-in-view' : ''}`}
            >
              <div className={`contentLeftBox ${styles.contentLeftBox}`}>
                {/* 移动端展示结构，pc下不显示 */}
                <div
                  className={classNames(
                    styles.contentLeftBoxHead,
                    showContentMore && styles.showContentMore
                  )}
                >
                  {/* <div
                    className={styles.contentLeftBoxHeadMore}
                    onClick={() => setShowContentMore(!showContentMore)}
                  ></div> */}
                  <div
                    className={classNames(
                      styles.contentLeftBoxHeadItem,
                      globalActive === 0 && styles.headActive
                    )}
                    onClick={() => handleGlobalMouseEnter(0)}
                  >
                    <img src={globalIconOne} />
                    <div className={styles.contentLeftBoxHeadTitle}>
                      {getFormatMessage('service_deployment')}
                    </div>
                  </div>
                  <div
                    className={classNames(
                      styles.contentLeftBoxHeadItem,
                      globalActive === 1 && styles.headActive
                    )}
                    onClick={() => handleGlobalMouseEnter(1)}
                  >
                    <img src={globalIconTwo} />
                    <div className={styles.contentLeftBoxHeadTitle}>
                      {getFormatMessage('global_team_support')}
                    </div>
                  </div>
                  <div
                    className={classNames(
                      styles.contentLeftBoxHeadItem,
                      globalActive === 2 && styles.headActive
                    )}
                    onClick={() => handleGlobalMouseEnter(2)}
                  >
                    <img src={globalIconThree} />
                    <div className={styles.contentLeftBoxHeadTitle}>
                      {getFormatMessage('multi_country')}
                    </div>
                  </div>
                  <div
                    className={classNames(
                      styles.contentLeftBoxHeadItem,
                      globalActive === 3 && styles.headActive
                    )}
                    onClick={() => handleGlobalMouseEnter(3)}
                  >
                    <img src={globalIconFour} />
                    <div className={styles.contentLeftBoxHeadTitle}>
                      {getFormatMessage('multilingual_support')}
                    </div>
                  </div>
                </div>
                <div
                  className={classNames(
                    styles.contentLeftItem,
                    globalActive === 0 ? styles.contentLeftItemActive : ''
                  )}
                  onMouseEnter={() => handleGlobalMouseEnter(0)}
                  style={{ marginTop: globalActive === 0 ? '52px' : '124px' }}
                >
                  {/* {showAurora && globalActive === 0 && (
                    <Aurora
                      colorStops={['#9543FF', '#1232A9', '#040210']}
                      blend={0.8}
                      amplitude={0.7}
                      speed={0.4}
                    />
                  )} */}
                  <div className={styles.itemLeft}>
                    {globalActive === 0 ? (
                      <img src={globalIconOneHover} />
                    ) : (
                      <img src={globalIconOne} />
                    )}
                  </div>
                  <div className={styles.itemRight}>
                    <div className={styles.itemRightMainTitle}>
                      {getFormatMessage('service_deployment')}
                    </div>
                    <div className={styles.itemRightMainDesc}>
                      {getFormatMessage('service_deployment_desc')}
                    </div>
                    <div
                      className={styles.itemRightTitle}
                      style={{ marginTop: '33px' }}
                    >
                      {getFormatMessage('game_server_deployment')}
                    </div>
                    <div className={styles.itemRightDesc}>
                      <span className={styles.itemRightDescLeft}>
                        {getFormatMessage('cn_shanghai')}
                      </span>
                      <span>{getFormatMessage('na_virginia')}</span>
                    </div>
                    <div
                      className={styles.itemRightDesc}
                      style={{ marginTop: '4px' }}
                    >
                      <span className={styles.itemRightDescLeft}>
                        {getFormatMessage('eu_frankfurt')}
                      </span>
                      <span>{getFormatMessage('ap_singapore')}</span>
                    </div>
                    <div
                      className={styles.itemRightTitle}
                      style={{ marginTop: '16px' }}
                    >
                      {getFormatMessage('dediacated_server_deployment')}
                    </div>
                    <div className={styles.itemRightDesc}>
                      {getFormatMessage('deployed_globally')}
                    </div>
                  </div>
                </div>
                <div
                  className={classNames(
                    styles.contentLeftItem,
                    globalActive === 1 ? styles.contentLeftItemActive : ''
                  )}
                  onMouseEnter={() => handleGlobalMouseEnter(1)}
                >
                  {/* {showAurora && globalActive === 1 && (
                    <Aurora
                      colorStops={['#9543FF', '#1232A9', '#040210']}
                      blend={0.8}
                      amplitude={0.7}
                      speed={0.4}
                    />
                  )} */}
                  <div className={styles.itemLeft}>
                    {globalActive === 1 ? (
                      <img src={globalIconTwoHover} />
                    ) : (
                      <img src={globalIconTwo} />
                    )}
                  </div>
                  <div className={styles.itemRight}>
                    <div className={styles.itemRightMainTitle}>
                      {getFormatMessage('global_team_support')}
                    </div>
                    <div className={styles.itemRightMainDesc}>
                      {getFormatMessage('global_team_support_desc')}
                    </div>
                  </div>
                </div>
                <div
                  className={classNames(
                    styles.contentLeftItem,
                    globalActive === 2 ? styles.contentLeftItemActive : ''
                  )}
                  onMouseEnter={() => handleGlobalMouseEnter(2)}
                >
                  {/* {showAurora && globalActive === 2 && (
                    <Aurora
                      colorStops={['#9543FF', '#1232A9', '#040210']}
                      blend={0.8}
                      amplitude={0.7}
                      speed={0.4}
                    />
                  )} */}
                  <div className={styles.itemLeft}>
                    {globalActive === 2 ? (
                      <img src={globalIconThreeHover} />
                    ) : (
                      <img src={globalIconThree} />
                    )}
                  </div>
                  <div className={styles.itemRight}>
                    <div className={styles.itemRightMainTitle}>
                      {getFormatMessage('multi_country')}
                    </div>
                    <div className={styles.itemRightMainDesc}>
                      {getFormatMessage('multi_country_desc')}
                    </div>
                  </div>
                </div>
                <div
                  className={classNames(
                    styles.contentLeftItem,
                    globalActive === 3 ? styles.contentLeftItemActive : ''
                  )}
                  onMouseEnter={() => handleGlobalMouseEnter(3)}
                >
                  {/* {showAurora && globalActive === 3 && (
                    <Aurora
                      colorStops={['#9543FF', '#1232A9', '#040210']}
                      blend={0.8}
                      amplitude={0.7}
                      speed={0.4}
                    />
                  )} */}
                  <div className={styles.itemLeft}>
                    {globalActive === 3 ? (
                      <img src={globalIconFourHover} />
                    ) : (
                      <img src={globalIconFour} />
                    )}
                  </div>
                  <div className={styles.itemRight}>
                    <div className={styles.itemRightMainTitle}>
                      {getFormatMessage('multilingual_support')}
                    </div>
                    <div className={styles.itemRightMainDesc}>
                      {getFormatMessage('multilingual_support_desc')}
                    </div>
                  </div>
                </div>
              </div>
              <div className={`contentRightBox ${styles.contentRightBox}`}>
                <div className={styles.iframeMask} onWheel={handleWheel}></div>
                {/* <iframe
                  // src="https://my.spline.design/untitledcopycopy-zc0ScPeBTQ3YUq8nP0h2Xw9v/"
                  src="/spline/my-spline-design.html"
                  width="100%"
                  height="100%"
                  style={{ border: 'none' }}
                  allowFullScreen
                  ref={iframeRef}
                ></iframe> */}
                {!isMobileCheck && (
                  <div className="spline-container">
                    <spline-viewer
                      ref={viewerRef}
                      // url="/api/website/spline-viewer/proxy/untitledcopycopy-zc0ScPeBTQ3YUq8nP0h2Xw9v/scene.splinecode"
                      url="/spline-static/scene.splinecode"
                      events-target="global"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.galaxyBox}>
          {/* {showAurora && (
            <Galaxy
              mouseRepulsion={false}
              mouseInteraction={true}
              density={2}
              glowIntensity={0.1}
              saturation={0.1}
              hueShift={360}
              twinkleIntensity={0.9}
              rotationSpeed={0}
              repulsionStrength={2}
              speed={0.6}
            />
          )} */}
          <div
            ref={divOurServiceRef}
            className={`parnterShowcaseBox  ${styles.parnterShowcaseBox} ${
              inOurServiceView ? 'our-service-in-view' : ''
            }`}
          >
            <div className={`ourServices ${styles.ourServices}`}>
              <span
                className={classNames(
                  styles.ourServicesSpan,
                  currentStoreLanguage === LanguageType.zh_CN
                    ? ''
                    : styles.ourServicesCourier
                )}
              >
                {getFormatMessage('parnter_showcase')}
              </span>
            </div>
            <div className={`ourServicesTips ${styles.ourServicesTips}`}>
              {getFormatMessage('parnter_showcase_desc')}
            </div>
            <div className={`parnterPngBox ${styles.parnterPngBox}`}>
              <LogoLoop
                logos={loopItems}
                speed={0}
                direction="left"
                logoHeight={80}
                gap={80}
                pauseOnHover
                scaleOnHover
                ariaLabel="Technology partners"
              />
              <div
                ref={divServiceBannerRef}
                className={`partnerSwiperPanel ${styles.partnerSwiperPanel} 
                ${inServiceBannerView ? 'service-banner-in-view' : ''}
                ${
                  isPlaying
                    ? `partner-playing ${styles.partnerSwiperPanelPlay}`
                    : ''
                } `}
              >
                {homePartnerBanner?.list && homePartnerBanner.list.length > 0 && (
                  <div
                    className={`swiper swiper-parnter`}
                    ref={(val) => {
                      setSwiperPartnerRef(val);
                    }}
                  >
                    <div className={`swiper-wrapper`}>
                      {homePartnerBanner.list.map((item: any) => {
                        return (
                          <div className={`swiper-slide`}>
                            <div className={styles.parnterCard}>
                              <div className={styles.parnterCardInner}>
                                <div className={styles.parnterCardCover}>
                                  <img
                                    src={getIconUrl(item?.cover || '')}
                                    alt=""
                                  />
                                </div>
                                <div className={styles.parnterCardContent}>
                                  <div className={styles.parnterCardTitle}>
                                    {item?.title || ''}
                                  </div>
                                  <div className={styles.parnterCardTags}>
                                    {item?.labels &&
                                      item.labels.length !== 0 &&
                                      item.labels.map((it: string) => {
                                        return (
                                          <div
                                            className={
                                              styles.parnterCardTagItem
                                            }
                                          >
                                            <span>{it}</span>
                                          </div>
                                        );
                                      })}
                                  </div>
                                  <div className={styles.parnterCardDesc}>
                                    {item?.desc || ''}
                                  </div>
                                  {item?.link && (
                                    <div className={styles.parnterCardAction}>
                                      <a
                                        className={styles.parnterCardButton}
                                        onClick={() =>
                                          clickFeatureBtn(item.link)
                                        }
                                      >
                                        <span>
                                          {getFormatMessage('find_out_more')}
                                        </span>
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className={styles.partnerSwiperItemBg}>
                                <div
                                  className={styles.partnerSwiperItemBgColor}
                                  style={{
                                    background: item?.themeColor || 'red',
                                  }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    {homePartnerBanner.list.length > 1 && (
                      <div className={styles.partnerSwiperPageWrap}>
                        <div
                          className={styles.partnerSwiperPlayControl}
                          onClick={toggleAutoplay}
                        >
                          <div className={styles.partnerSwiperPlayButton}></div>
                        </div>
                        <div
                          className={`swiper-pagination swiper-pagination-parnter ${styles.partnerSwiperPage}`}
                        ></div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.getStartedBgBox}>
            <div className={styles.securityAssuranceBgBox}>
              <div className={styles.securityAssuranceBox}>
                <div className={styles.ourServices}>
                  <span
                    className={classNames(
                      styles.ourServicesSpan,
                      currentStoreLanguage === LanguageType.zh_CN
                        ? ''
                        : styles.ourServicesCourier
                    )}
                  >
                    {getFormatMessage('security_assurance')}
                  </span>
                </div>
                <div className={styles.ourServicesTips}>
                  {getFormatMessage('security_statement')}
                </div>
                <div className={styles.ourServicesDesc}>
                  {getFormatMessage('security_statement_desc')}
                </div>
                <div className={styles.securityAssurancePngBox}>
                  {!securityAnimated ? (
                    <AnimatedContent
                      distance={60}
                      direction="vertical"
                      reverse={false}
                      duration={1}
                      ease="power3.out"
                      initialOpacity={0}
                      animateOpacity
                      scale={0.6}
                      threshold={0.1}
                      delay={0.3}
                      onComplete={() => setSecurityAnimated(true)}
                    >
                      <img
                        src={dnvLeft}
                        className={styles.securityAssurancePng}
                      />
                    </AnimatedContent>
                  ) : (
                    <img
                      src={dnvLeft}
                      className={styles.securityAssurancePng}
                    />
                  )}
                  {!securityAnimated ? (
                    <AnimatedContent
                      distance={60}
                      direction="vertical"
                      reverse={false}
                      duration={1}
                      ease="power3.out"
                      initialOpacity={0}
                      animateOpacity
                      scale={0.6}
                      threshold={0.1}
                      delay={0.3}
                      onComplete={() => console.log('AnimatedContent')}
                    >
                      <img
                        src={dnvRight}
                        className={styles.securityAssurancePng}
                      />
                    </AnimatedContent>
                  ) : (
                    <img
                      src={dnvRight}
                      className={styles.securityAssurancePng}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className={styles.getStartedBox}>
              <img src={homeBgSix} className={styles.homeBgSix} />
              <div className={styles.ourServices}>
                <span
                  className={classNames(
                    styles.ourServicesSpan,
                    currentStoreLanguage === LanguageType.zh_CN
                      ? ''
                      : styles.ourServicesCourier
                  )}
                >
                  {getFormatMessage('new_get_started')}
                </span>
              </div>
              <div className={styles.ourServicesTips}>
                {/* <ScrollFloat
                  animationDuration={1}
                  ease="power2.out"
                  // scrollStart='center bottom+=50%'
                  scrollStart='top 95%'
                  // scrollEnd='bottom bottom-=40%'
                  scrollEnd='bottom 5%'
                  stagger={0.03}
                  scrollContainerRef={undefined}
                > */}
                <GradientText
                  colors={['#E8EEFF, #5764F1, #E8EEFF, #5764F1, #6E3AFF']}
                  animationSpeed={10}
                  showBorder={false}
                  className="custom-class"
                >
                  {getFormatMessage('ready_to_try')}
                </GradientText>
                {/* </ScrollFloat> */}
              </div>
              <div
                className={styles.ourServicesDesc}
                style={{ marginTop: '8px' }}
              >
                {getFormatMessage('get_started_now')}
              </div>
              <div
                className={styles.ourServicesDesc}
                style={{ marginTop: '4px' }}
              >
                {getFormatMessage('let_innovate_experiences_desc')}
              </div>
              <div className={styles.getStartedSearchBox}>
                {isWoa ? (
                  <>
                    <Input
                      placeholder={getFormatMessage('enter_wecom_name')}
                      size="large"
                      className={styles.getStartedSearchWoa}
                      onChange={(e) => setEmail(e.target.value)}
                      prefix={
                        <img
                          src={contactIcon}
                          style={{ width: 20, height: 18 }}
                        />
                      }
                      addonAfter="@tencent.com"
                    />
                    <div
                      className={styles.getStartedWoaBtn}
                      onClick={handleSearch}
                    >
                      {getFormatMessage('start_for_free_new')}
                    </div>
                  </>
                ) : (
                  <Search
                    placeholder={getFormatMessage('enter_email_address')}
                    // allowClear
                    enterButton={getFormatMessage('start_for_free_new')}
                    size="large"
                    className={styles.getStartedSearch}
                    onSearch={handleSearch}
                    prefix={
                      <img
                        src={contactIcon}
                        style={{ width: 20, height: 18 }}
                      />
                    }
                    onChange={(e) => setEmail(e.target.value)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <Modal
          className={styles.homeVideo}
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={null}
          width={850}
        >
          <video width="100%" ref={videoRef} autoPlay controls>
            <source src={getVideoUrl()} type="video/mp4" />
          </video>
        </Modal>
      </div>
    </LayoutDefault>
  );
};
